import { render, staticRenderFns } from "./RequestsTab.vue?vue&type=template&id=545e7c6a&scoped=true"
import script from "@/views/Requests/RequestsTab/RequestsTab.ts?vue&type=script&lang=ts&external"
export * from "@/views/Requests/RequestsTab/RequestsTab.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Requests/RequestsTab/requests-tab.scss?vue&type=style&index=0&id=545e7c6a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e7c6a",
  null
  
)

export default component.exports